import React from 'react';
import { Box, Grid, Hidden, Modal } from '@mui/material';
import StepperManagement from '../components/stepperManagement';
import { makeStyles } from 'tss-react/mui';
import SearchForm from '../components/searchForm';

const SearchBooking = () => {
  const useStyles = makeStyles()((theme) => {
    return {
      container: {
        [theme.breakpoints.down('sm')]: {
          backgroundColor: theme.palette.secondary.main,
          height: '100vh'
        }
      },
      modalContainer: {
        '.MuiBackdrop-root': {
          backgroundColor: 'transparent!important'
        }
      }
    };
  });

  const { classes } = useStyles();

  return (
    <Box pt={5} pb={5} className={classes.container}>
      <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
        <Grid item xs={12} md={11}>
          <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <Hidden smDown>
              <Grid item sm={4} md={4} lg={3}>
                <StepperManagement step={0} />
              </Grid>
            </Hidden>
            <Hidden smUp>
              <Modal
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className={classes.modalContainer}>
                <Box pt={5}>
                  <SearchForm />
                </Box>
              </Modal>
            </Hidden>

            <Hidden smDown>
              <SearchForm />
            </Hidden>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchBooking;
